import { t } from "@/i18n-js/instance";
import { Collapsible } from "@circle-react-uikit/Collapsible";
import { Form } from "@circle-react-uikit/Form";
import { SliderField } from "../../../../Editor/fields/SliderField";
import { useCustomColors } from "../../../../ThemeConfiguration/hooks/useCustomColors";
import type { ButtonVariant } from "./ButtonStateSelector";
import { generateFormItemName } from "./Styles";
import type { ButtonType } from "./constants";

interface BordersProps {
  buttonType: ButtonType;
  selectedButtonVariant: ButtonVariant;
}

export const Borders = ({
  selectedButtonVariant,
  buttonType,
}: BordersProps) => {
  const { flattenedCssVariables } = useCustomColors();
  return (
    <Collapsible title={t("builder_ui.prop_type.styles.border")} defaultOpen>
      <div className="space-y-4 px-6 py-5">
        <Form.Item
          name={generateFormItemName(
            buttonType,
            selectedButtonVariant,
            "borderColor",
          )}
          label={t("builder_ui.prop_type.styles.border_color")}
          hideDescription
          hideBorder
          className="!flex !w-full !items-center !justify-between !p-0"
        >
          <Form.ColorPickerV2
            name={generateFormItemName(
              buttonType,
              selectedButtonVariant,
              "borderColor",
            )}
            cssVariables={flattenedCssVariables}
            shouldResolveCssVariable
          />
        </Form.Item>

        <SliderField
          name={generateFormItemName(
            buttonType,
            selectedButtonVariant,
            "borderWidth",
          )}
          label={t("builder_ui.prop_type.styles.border_width")}
          units={["px", "rem"]}
          step={1}
          min={0}
          max={100}
        />
      </div>
    </Collapsible>
  );
};
